import rest from 'redux/rest'
import { reducers, getState } from 'redux/core'


const stopFetching = () => {
  reducers.view.fragranceOfTheMonthPage.setFetching(false)
}

const fetch = (query) => {
  reducers.view.fragranceOfTheMonthPage.setFetching(true)

  return rest.view.fragranceOfTheMonthPage.fetchFragranceOfTheMonthData({
    query,
  })
    .then(
      (result) => {
        if (!result.pom || Array.isArray(result.pom)) {
          stopFetching()

          return
        }

        reducers.view.fragranceOfTheMonthPage.setFomData(result.pom)

        rest.view.fragranceOfTheMonthPage.fetchFragranceData({
          productId: result.pom.perfume.id,
        })
          .then(
            (result) => reducers.view.fragranceOfTheMonthPage.setProductData(result),
            () => {
              stopFetching()
              return Promise.reject()
            }
          )
      },
      () => {
        stopFetching()
        return Promise.reject()
      }
    )
}

const setActiveVolumeIndex = (index) => reducers.view.fragranceOfTheMonthPage.setActiveVolumeIndex(index)

const getActiveVolume = () => {
  let { view: { fragranceOfTheMonthPage: { productData: { volumes, activeVolumeIndex } } } } = getState()

  if (activeVolumeIndex === null) {
    activeVolumeIndex = 0
  }

  return volumes[activeVolumeIndex]
}

export default {
  fetch,
  setActiveVolumeIndex,
  getActiveVolume,
}
